import { createContext } from 'react';

import { IBurgerContext, defaultBurgerState } from '@app/objects/BurgerContext';

export const BurgerContext = createContext<IBurgerContext>(defaultBurgerState);
